/**
 * Mapping of ADK agents/authors to human-readable text
 * Used to display status messages next to the spinner during processing
 */
export const AUTHOR_MAPPING = {
  // Main orchestration agents
  rise_ai_llm_agent: "Processing your request",
  intent_analyzer: "Analyzing your question",
  workflow_router: "Routing to appropriate handler",
  metadata_answer: "Retrieving metadata",
  direct_answer: "Formulating answer",
  
  // Retrieval flow agents
  retrieval_flow: "Retrieving data",
  data_router: "Routing data request",
  presenter: "Formatting results",
  retrieval_component_reader: "Reading component data",
  retrieval_vulnerability_reader: "Reading vulnerability data",
  component_filter_builder: "Building component filter",
  component_tool_executor: "Fetching components",
  vulnerability_filter_builder: "Building vulnerability filter",
  vulnerability_tool_executor: "Fetching vulnerabilities",
  retrieval_component_filter_builder: "Preparing component search",
  retrieval_component_tool_executor: "Retrieving components",
  retrieval_vulnerability_filter_builder: "Preparing vulnerability search",
  retrieval_vulnerability_tool_executor: "Retrieving vulnerabilities",
  
  // Vulnerability remediation flow agents
  remediation_proposal_flow: "Analyzing remediation options",
  remediation_execution_flow: "Executing remediations",
  remediation_proposer: "Proposing remediation plan",
  remediation_confirmation: "Confirming remediation details",
  remediation_executor: "Applying remediations",
  remediation_summary: "Summarizing results",
  remediation_component_reader: "Reading affected components",
  remediation_vulnerability_reader: "Reading vulnerabilities to remediate",
  remediation_vulnerability_filter_builder: "Preparing remediation search",
  remediation_vulnerability_tool_executor: "Retrieving vulnerabilities to remediate",
  
  // Component remediation flow agents
  component_remediation_proposal_flow: "Analyzing component updates",
  component_remediation_execution_flow: "Updating components",
  component_remediation_proposer: "Proposing component changes",
  component_remediation_confirmation: "Confirming component updates",
  component_remediation_executor: "Applying component changes",
  component_remediation_summary: "Summarizing changes",
  component_remediation_component_reader: "Reading component details",
  component_remediation_vulnerability_reader: "Reading component to remediate",
  component_remediation_vulnerability_filter_builder: "Preparing remediation search",
  component_remediation_vulnerability_tool_executor: "Retrieving components to remediate",
  // Tools
  read_vulnerabilities: "Reading vulnerabilities",
  read_asset_components: "Reading components",
  present_vulnerabilities: "Formatting vulnerabilities",
  present_components: "Formatting components",
  get_session_context: "Getting context",
  set_dry_run: "Setting dry-run mode",
  add_identification: "Adding component identification",
  bulk_remove_identifications: "Removing identifications",
  modify_identification: "Modifying identification",
  present_error: "Formatting error",
  remediate_vulnerability: "Remediating vulnerability",
  get_asset_metadata: "Getting asset metadata",
  get_insights_report: "Getting insights report",
  session_settings: "Setting session settings"
};

/**
 * Completion text shown when the spinner finishes processing
 */
export const COMPLETION_TEXT = "Ready";

/**
 * Get human-readable text for an author/agent
 * @param {string} author - The author/agent name from ADK
 * @returns {string} Human-readable text, or default message if not found
 */
export function getAuthorText(author) {
  if (!author) return "RiseAI is thinking...";
  return AUTHOR_MAPPING[author] || "Processing...";
}
